export const percentageFees = 1.5;

export const fixedFee = 0.25;

export const IVA = 22;
